import React from 'react';
import { NavLink } from 'react-router-dom';
import CustomForm from 'components/Form/CustomForm';
import useForgotPassword from '../../hooks/useForgotPassword';
import styles from './ForgotPasswordForm.module.scss';

function ForgotPasswordForm() {
  const { fields, formValue, isLoading, model, onChange, onSubmit } =
    useForgotPassword();

  return (
    <div className={styles.container}>
      <div className={styles.formHeader}>
        <h1 className={styles.title}>Forgot your password?</h1>
        <p className={styles.message}>
          Enter your profile email address and we will send you instructions to
          reset your password.
        </p>
        <p className={styles.warn}>
          You may have to check your spam or junk folder.
        </p>
      </div>

      <CustomForm
        onChange={onChange}
        onSubmit={onSubmit}
        model={model}
        formValue={formValue}
        isLoading={isLoading}
        fields={fields}
        isDisabled={false}
        submitLabel="Send Password Reset Instructions"
        hasChanges
        submitBtnSize="full"
      />

      <div className={styles.linksContainer}>
        <NavLink className={styles.customLink} to="/">
          <p>Return to login.</p>
        </NavLink>
      </div>
    </div>
  );
}

export default ForgotPasswordForm;
